import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { NotificationManager } from "react-notifications";
import { initialize as initializeForm } from 'redux-form';
import { api } from "api";
import Swal from 'sweetalert2';
import { months } from '../../../common/components/Utils/months';
import { result } from 'lodash';
const alerta = require('assets/img/icons/activo.png');

let url = 'shopping';
let form = 'ShoppingForm';
// ------------------------------------
// Constants
// ------------------------------------

export const constants = {
    LOADER: 'SHOPPING_LOADER',
    DATA: 'SHOPPING_DATA',
    DATA_ANNUAL: 'SHOPPING_DATA_ANNUAL',
    ITEM_DATA: 'SHOPPING_ITEM',
    PAGE: 'SHOPPING_PAGE',
    ORDERING: 'SHOPPING_ORDERING',
    SEARCH: 'SHOPPING_SEARCH',
    TAB_EN_CURSO: 'SHOPPING_TAB_EN_CURSO',
    TAB_PROYECCIONES_ANUALES: 'TAB_PROYECCIONES_ANUALES',
    PAGE_EN_CURSO: 'PAGE_EN_CURSO',
    PAGE_ANUALES: 'PAGE_ANUALES',
    LATEX_TABLE: 'LATEX_TABLE',
    CHIPA_TABLE: 'CHIPA_TABLE',
    SET_STEP: 'SET_STEP_SHOPPING'
}

// -----------------------------------
// Pure Actions
// -----------------------------------
const setLoader = loader => ({
    type: constants.LOADER,
    loader,
});
const setData = data => ({
    type: constants.DATA,
    data,
});
const setDataAnnual = data_annual => ({
    type: constants.DATA_ANNUAL,
    data_annual,
});
const setItem = item => ({
    type: constants.ITEM_DATA,
    item,
});
const setStep = (step) => ({
    type: constants.SET_STEP,
    step,
});

const confirm_shopping_save = (dispatch) => {
    const SwalMod = Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-primary btn-modal',
            content: '',
            title: 'darck',
            popup: 'custom-modal-size',
        },
        buttonsStyling: false,
        showCloseButton: true,
        focusConfirm: false,
        padding: "1em",
    });

    SwalMod.fire({
        title: 'FELICIDADES',
        text: 'Tu formulario se ha actualizado de forma exitosa',
        imageUrl: alerta,
        imageAlt: 'Alerta',
        confirmButtonText: 'CONTINUAR',
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            dispatch(setStep(1))
            dispatch(read())
        } else {
            dispatch(read())
            dispatch(setStep(1))
        }
    });
}

// -----------------------------------
// Actions
// -----------------------------------


const read = year => (dispatch) => {
    dispatch(setLoader(true));
    const params = { year: year };

    api.get(`${url}/get_shopping`, params)
        .then((response) => {
            const { results, dollar_exchange } = response;

            dispatch(setData(response));
            dispatch(setItem(dollar_exchange));
            const latex_table = processDataForLatexTable(response, false);
            const chipa_table = processDataForChipaTable(response, false);
            dispatch({
                type: constants.LATEX_TABLE,
                latex_table
            });
            dispatch({
                type: constants.CHIPA_TABLE,
                chipa_table
            });
            const formData = {
                ...results,
                latex_table: latex_table,
                chipa_table: chipa_table
            };
            dispatch(initializeForm(form, formData));
        })
            
        .catch((error) => {
            console.error('Error fetching data:', error);
            NotificationManager.error((error && error.detail) ? error.detail : 'Error en lectura de datos', 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};


const processDataForLatexTable = (data, annual) => {
    const { results, drc_promedio_general_latex, latex_table_calculated, data_equivalent_kilos } = data;
    
    // Si tenemos datos calculados del backend, usarlos directamente
    if (latex_table_calculated && data_equivalent_kilos) {
        // Procesar datos del backend
        const processedTable = latex_table_calculated.map((item) => ({
            name: item.name,
            total: item.total || 0,
            is_kg: item.is_kg || false,
            is_drc: item.is_drc || false,
            shopping_save: item.shopping_save || false,
            is_iva_credit: item.is_iva_credit || false,
            // Convertir item.data a propiedades directas para cada mes
            enero: (item.data && item.data.enero) || 0,
            febrero: (item.data && item.data.febrero) || 0,
            marzo: (item.data && item.data.marzo) || 0,
            abril: (item.data && item.data.abril) || 0,
            mayo: (item.data && item.data.mayo) || 0,
            junio: (item.data && item.data.junio) || 0,
            julio: (item.data && item.data.julio) || 0,
            agosto: (item.data && item.data.agosto) || 0,
            septiembre: (item.data && item.data.septiembre) || 0,
            octubre: (item.data && item.data.octubre) || 0,
            noviembre: (item.data && item.data.noviembre) || 0,
            diciembre: (item.data && item.data.diciembre) || 0
        }));

        // Obtener datos reales del DRC
        const drc_latex_data = annual ? 
            drc_promedio_general_latex : 
            (results && results.drc_promedio_general_latex && results.drc_promedio_general_latex.generic_row && results.drc_promedio_general_latex.generic_row[0]) || {};
        
        // Calcular total del DRC (promedio)
        const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
        let drcTotal = 0;
        let drcCount = 0;
        
        months.forEach(month => {
            const drcValue = drc_latex_data[month] || 30; // Fallback a 30 si no hay dato
            if (drcValue > 0) {
                drcTotal += drcValue;
                drcCount++;
            }
        });
        
        const drcAverage = drcCount > 0 ? drcTotal / drcCount : 30;

        // Construir tabla final con filas especiales en el orden correcto
        const finalTable = [
            processedTable[0], // Compra de látex (costo neto)
            {
                name: 'kILOS hUMEDOS',
                is_kg: true,
                total: 0,
                enero: 0, febrero: 0, marzo: 0, abril: 0, mayo: 0, junio: 0,
                julio: 0, agosto: 0, septiembre: 0, octubre: 0, noviembre: 0, diciembre: 0
            },
            {
                name: 'drc promedio general',
                is_drc: true,
                total: drcAverage,
                // Usar los valores reales del DRC con fallback a 30
                enero: drc_latex_data.enero || 30,
                febrero: drc_latex_data.febrero || 30,
                marzo: drc_latex_data.marzo || 30,
                abril: drc_latex_data.abril || 30,
                mayo: drc_latex_data.mayo || 30,
                junio: drc_latex_data.junio || 30,
                julio: drc_latex_data.julio || 30,
                agosto: drc_latex_data.agosto || 30,
                septiembre: drc_latex_data.septiembre || 30,
                octubre: drc_latex_data.octubre || 30,
                noviembre: drc_latex_data.noviembre || 30,
                diciembre: drc_latex_data.diciembre || 30
            },
            ...processedTable.slice(1) // Resto de las filas pre-calculadas
        ];

        return finalTable;
    }
    
    // Fallback al método anterior si no hay datos calculados
    const drc_latex_initial = annual ? drc_promedio_general_latex : (results && results.drc_promedio_general_latex && results.drc_promedio_general_latex.generic_row && results.drc_promedio_general_latex.generic_row[0]) || [];
    
    const latex_table = [
        { name: 'Compra de látex (costo neto)' },
        { name: 'kILOS hUMEDOS' },
        { name: 'drc promedio general', data: drc_latex_initial, is_drc: true },
    ];
    
    latex_table.forEach(item => {
        item.total = 0;
        if (item.data) {
            for (let mes in item.data) {
                item.total += item.data[mes];
            }
            Object.assign(item, item.data);
        }
    });

    return latex_table;
}

const processDataForChipaTable = (data, annual) => {
    const { results, drc_promedio_general_chipa, chipa_table_calculated, data_equivalent_kilos_chipa } = data;
    
    // Si tenemos datos calculados del backend, usarlos directamente
    if (chipa_table_calculated && data_equivalent_kilos_chipa) {
        // Procesar datos del backend
        const processedTable = chipa_table_calculated.map((item) => ({
            name: item.name,
            total: item.total || 0,
            is_kg: item.is_kg || false,
            is_drc: item.is_drc || false,
            shopping_save: item.shopping_save || false,
            is_iva_credit: item.is_iva_credit || false,
            // Convertir item.data a propiedades directas para cada mes
            enero: (item.data && item.data.enero) || 0,
            febrero: (item.data && item.data.febrero) || 0,
            marzo: (item.data && item.data.marzo) || 0,
            abril: (item.data && item.data.abril) || 0,
            mayo: (item.data && item.data.mayo) || 0,
            junio: (item.data && item.data.junio) || 0,
            julio: (item.data && item.data.julio) || 0,
            agosto: (item.data && item.data.agosto) || 0,
            septiembre: (item.data && item.data.septiembre) || 0,
            octubre: (item.data && item.data.octubre) || 0,
            noviembre: (item.data && item.data.noviembre) || 0,
            diciembre: (item.data && item.data.diciembre) || 0
        }));

        // Obtener datos reales del DRC para chipa
        const drc_chipa_data = annual ? 
            drc_promedio_general_chipa : 
            (results && results.drc_promedio_general_chipa && results.drc_promedio_general_chipa.generic_row && results.drc_promedio_general_chipa.generic_row[0]) || {};
        
        // Calcular total del DRC (promedio)
        const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
        let drcTotal = 0;
        let drcCount = 0;
        
        months.forEach(month => {
            const drcValue = drc_chipa_data[month] || 30; // Fallback a 30 si no hay dato
            if (drcValue > 0) {
                drcTotal += drcValue;
                drcCount++;
            }
        });
        
        const drcAverage = drcCount > 0 ? drcTotal / drcCount : 30;

        // Construir tabla final con filas especiales en el orden correcto
        const finalTable = [
            processedTable[0], // Compra de chipa (costo neto)
            {
                name: 'kILOS hUMEDOS',
                is_kg: true,
                total: 0,
                enero: 0, febrero: 0, marzo: 0, abril: 0, mayo: 0, junio: 0,
                julio: 0, agosto: 0, septiembre: 0, octubre: 0, noviembre: 0, diciembre: 0
            },
            {
                name: 'drc promedio general',
                is_drc: true,
                total: drcAverage,
                // Usar los valores reales del DRC con fallback a 30
                enero: drc_chipa_data.enero || 30,
                febrero: drc_chipa_data.febrero || 30,
                marzo: drc_chipa_data.marzo || 30,
                abril: drc_chipa_data.abril || 30,
                mayo: drc_chipa_data.mayo || 30,
                junio: drc_chipa_data.junio || 30,
                julio: drc_chipa_data.julio || 30,
                agosto: drc_chipa_data.agosto || 30,
                septiembre: drc_chipa_data.septiembre || 30,
                octubre: drc_chipa_data.octubre || 30,
                noviembre: drc_chipa_data.noviembre || 30,
                diciembre: drc_chipa_data.diciembre || 30
            },
            ...processedTable.slice(1) // Resto de las filas pre-calculadas
        ];

        return finalTable;
    }
    
    // Fallback al método anterior si no hay datos calculados
    const drc_chipa_initial = annual ? drc_promedio_general_chipa : (results && results.drc_promedio_general_chipa && results.drc_promedio_general_chipa.generic_row && results.drc_promedio_general_chipa.generic_row[0]) || [];

    const chipa_table = [
        { name: 'Compra de chipa (costo neto)' },
        { name: 'kILOS hUMEDOS' },
        { name: 'drc promedio general', data: drc_chipa_initial, is_drc: true },
        { name: 'kilos secos equivalentes' },
        { name: 'precio por kilo seco (sin iva)' },
        { name: 'Precio por kilo seco (CON IVA)' },
        { name: 'PAGO NETO POR COMPRAS SIN IVA' },
        { name: 'PAGO BRUTO POR COMPRAS CON IVA' },
        { name: 'IMPORTE DEL IVA PAGADO' },
    ];
    
    chipa_table.forEach(item => {
        item.total = 0;
        if (item.data) {
            for (let mes in item.data) {
                item.total += item.data[mes];
            }
            Object.assign(item, item.data);
        }
    });

    return chipa_table;
}

// Procesadores específicos para datos anuales
const processDataForAnnualLatexTable = (data) => {
    const { latex_table_annual_calculated, drc_promedio_general_latex, year_list } = data;
    
    // Si tenemos datos calculados del backend, usarlos directamente
    if (latex_table_annual_calculated && year_list) {
        // Procesar datos del backend con estructura anual
        const processedTable = latex_table_annual_calculated.map((item) => {
            const row = {
                name: item.name,
                total: item.total || 0,
                is_kg: item.is_kg || false,
                is_drc: item.is_drc || false,
                shopping_save: item.shopping_save || false,
                is_iva_credit: item.is_iva_credit || false,
            };
            
            // Agregar cada año como propiedad directa
            year_list.forEach(year => {
                row[year] = (item.data && item.data[year]) || 0;
            });
            
            return row;
        });

        // Obtener datos reales del DRC para años
        const drc_latex_data = drc_promedio_general_latex || {};
        
        // Calcular total del DRC (promedio)
        let drcTotal = 0;
        let drcCount = 0;
        
        year_list.forEach(year => {
            const drcValue = drc_latex_data[year] || 30; // Fallback a 30 si no hay dato
            if (drcValue > 0) {
                drcTotal += drcValue;
                drcCount++;
            }
        });
        
        const drcAverage = drcCount > 0 ? drcTotal / drcCount : 30;

        // Construir tabla final con filas especiales en el orden correcto
        const finalTable = [
            processedTable[0] || { name: 'Compra de látex (costo neto)', total: 0 },
            {
                name: 'kILOS hUMEDOS',
                is_kg: true,
                total: 0,
                ...Object.fromEntries(year_list.map(year => [year, 0]))
            },
            {
                name: 'drc promedio general',
                is_drc: true,
                total: drcAverage,
                // Usar los valores reales del DRC con fallback a 30
                ...Object.fromEntries(year_list.map(year => [year, drc_latex_data[year] || 30]))
            },
            ...processedTable.slice(1) // Resto de las filas pre-calculadas
        ];

        return finalTable;
    }
    
    // Fallback básico si no hay datos calculados
    const latex_table = [
        { name: 'Compra de látex (costo neto)', total: 0 },
        { name: 'kILOS hUMEDOS', is_kg: true, total: 0 },
        { name: 'drc promedio general', is_drc: true, total: 30 },
    ];
    
    // Agregar años como propiedades vacías
    if (year_list) {
        latex_table.forEach(item => {
            year_list.forEach(year => {
                item[year] = item.name === 'drc promedio general' ? 30 : 0;
            });
        });
    }

    return latex_table;
}

const processDataForAnnualChipaTable = (data) => {
    const { chipa_table_annual_calculated, drc_promedio_general_chipa, year_list } = data;
    
    // Si tenemos datos calculados del backend, usarlos directamente
    if (chipa_table_annual_calculated && year_list) {
        // Procesar datos del backend con estructura anual
        const processedTable = chipa_table_annual_calculated.map((item) => {
            const row = {
                name: item.name,
                total: item.total || 0,
                is_kg: item.is_kg || false,
                is_drc: item.is_drc || false,
                shopping_save: item.shopping_save || false,
                is_iva_credit: item.is_iva_credit || false,
            };
            
            // Agregar cada año como propiedad directa
            year_list.forEach(year => {
                row[year] = item[year] || 0;
            });
            
            return row;
        });

        // Obtener datos reales del DRC para años
        const drc_chipa_data = drc_promedio_general_chipa || {};
        
        // Calcular total del DRC (promedio)
        let drcTotal = 0;
        let drcCount = 0;
        
        year_list.forEach(year => {
            const drcValue = drc_chipa_data[year] || 30; // Fallback a 30 si no hay dato
            if (drcValue > 0) {
                drcTotal += drcValue;
                drcCount++;
            }
        });
        
        const drcAverage = drcCount > 0 ? drcTotal / drcCount : 30;

        // Construir tabla final con filas especiales en el orden correcto
        const finalTable = [
            processedTable[0] || { name: 'Compra de chipa (costo neto)', total: 0 },
            {
                name: 'kILOS hUMEDOS',
                is_kg: true,
                total: 0,
                ...Object.fromEntries(year_list.map(year => [year, 0]))
            },
            {
                name: 'drc promedio general',
                is_drc: true,
                total: drcAverage,
                // Usar los valores reales del DRC con fallback a 30
                ...Object.fromEntries(year_list.map(year => [year, drc_chipa_data[year] || 30]))
            },
            ...processedTable.slice(1) // Resto de las filas pre-calculadas
        ];

        return finalTable;
    }
    
    // Fallback básico si no hay datos calculados
    const chipa_table = [
        { name: 'Compra de chipa (costo neto)', total: 0 },
        { name: 'kILOS hUMEDOS', is_kg: true, total: 0 },
        { name: 'drc promedio general', is_drc: true, total: 30 },
        { name: 'kilos secos equivalentes', is_kg: true, total: 0 },
        { name: 'precio por kilo seco (sin iva)', total: 0 },
        { name: 'Precio por kilo seco (CON IVA)', total: 0 },
        { name: 'PAGO NETO POR COMPRAS SIN IVA', total: 0 },
        { name: 'PAGO BRUTO POR COMPRAS CON IVA', total: 0 },
        { name: 'IMPORTE DEL IVA PAGADO', total: 0 },
    ];
    
    // Agregar años como propiedades vacías
    if (year_list) {
        chipa_table.forEach(item => {
            year_list.forEach(year => {
                item[year] = item.name === 'drc promedio general' ? 30 : 0;
            });
        });
    }

    return chipa_table;
}

const getDollar = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`administrative/get_dollar_exchange`).then((response) => {
        dispatch(setItem(response.dollar_exchange));
        dispatch(initializeForm(form, response.results));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${url}/${id}`, data).then(() => {
        confirm_shopping_save(dispatch);
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const summary_annual_list = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${url}/get_annual_shopping_budget`).then((response) => {        
            const { dollar_exchange } = response;
            dispatch(setItem(dollar_exchange));
            dispatch(setDataAnnual(response));
            
            // Usar procesadores específicos para datos anuales
            const latex_table = processDataForAnnualLatexTable(response);
            const chipa_table = processDataForAnnualChipaTable(response);
            
            dispatch({
                type: constants.LATEX_TABLE,
                latex_table
            });
            dispatch({
                type: constants.CHIPA_TABLE,
                chipa_table
            });
            
            const formData = {
                ...response,
                latex_table: latex_table,
                chipa_table: chipa_table
            };
            
            dispatch(initializeForm('ShoppingFormAnnual', formData));  
    }).catch((error) => {
        console.error('Error fetching annual data:', error);
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en lectura de datos anuales', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const edit_annual = (data) => (dispatch) => {
    dispatch(setLoader(true));
    api.post(`${url}/shopping_annual_update`, data).then(() => {
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
        dispatch(push('/shopping/summary'));
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

//  ----------------
// Shopping Resumen
// -----------------

const setTab = (tab) => (dispatch) => {
    dispatch(setLoader(true));
    dispatch({ type: constants.TAB_EN_CURSO, tab });
    dispatch(setLoader(false));
};


export const actions = {
    editar,
    read,
    getDollar,
    setTab,
    processDataForLatexTable,
    processDataForChipaTable,
    processDataForAnnualLatexTable,
    processDataForAnnualChipaTable,
    setStep,
    summary_annual_list,
    edit_annual

};
// -----------------------------------
// Reducers
// -----------------------------------
const reducers = {
    [constants.LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [constants.DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [constants.DATA_ANNUAL]: (state, { data_annual }) => {
        return {
            ...state,
            data_annual,
        };
    },
    [constants.ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [constants.PAGE_EN_CURSO]: (state, { page_activas }) => {
        return {
            ...state,
            page_activas,
        };
    },
    [constants.PAGE_ANUALES]: (state, { page_finalizadas }) => {
        return {
            ...state,
            page_finalizadas,
        };
    },

    [constants.TAB_EN_CURSO]: (state, { tab }) => {
        return {
            ...state,
            tab,
        };
    },
    [constants.TAB_PROYECCIONES_ANUALES]: (state, { tab_anuales }) => {
        return {
            ...state,
            tab_anuales,
        };
    },
    [constants.LATEX_TABLE]: (state, { latex_table }) => {
        return {
            ...state,
            latex_table,
        };
    },
    [constants.CHIPA_TABLE]: (state, { chipa_table }) => {
        return {
            ...state,
            chipa_table,
        };
    },
    [constants.SET_STEP]: (state, { step }) => {
        return {
            ...state,
            step,
        };
    },

};
export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    latex_table: {},
    chipa_table: {},
    item: {},
    tab: 'EN_CURSO',
    step: 1,
    data_annual:{
        results: [],
        count: 0,
    }

};
export default handleActions(reducers, initialState)